import type { ColorMode } from "@chakra-ui/react";

const STORAGE_KEY = "gg-hub:color-mode";

const persistence = {
  read(): string | null {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch {
      return null;
    }
  },
  write(value: string) {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch {
      // noop
    }
  },
};

export const ggColorModeManager = {
  type: "localStorage" as const,
  ssr: false,
  get(initialValue: ColorMode = "light"): ColorMode {
    if (typeof window === "undefined") return initialValue;
    const stored = persistence.read();
    return (stored === "light" || stored === "dark" ? stored : initialValue);
  },
  set(value: ColorMode | "system") {
    if (typeof window === "undefined") return;
    persistence.write(value);
  },
};
